import type { ComponentProps } from "react"

export default function BRA(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M2.62695 10.6265V1.62646C2.62695 1.36125 2.73231 1.10689 2.91985 0.919358C3.10738 0.731822 3.36174 0.626465 3.62695 0.626465H7.62695C7.89217 0.626465 8.14652 0.731822 8.33406 0.919358C8.5216 1.10689 8.62695 1.36125 8.62695 1.62646V10.6265M2.62695 10.6265H8.62695M2.62695 10.6265H1.62695C1.36174 10.6265 1.10738 10.5211 0.919846 10.3336C0.73231 10.146 0.626953 9.89168 0.626953 9.62646V6.62646C0.626953 6.36125 0.73231 6.10689 0.919846 5.91936C1.10738 5.73182 1.36174 5.62646 1.62695 5.62646H2.62695M8.62695 10.6265H9.62695C9.89217 10.6265 10.1465 10.5211 10.3341 10.3336C10.5216 10.146 10.627 9.89168 10.627 9.62646V5.12646C10.627 4.86125 10.5216 4.60689 10.3341 4.41936C10.1465 4.23182 9.89217 4.12647 9.62695 4.12647H8.62695M4.62695 2.62646H6.62695M4.62695 4.62646H6.62695M4.62695 6.62646H6.62695M4.62695 8.62647H6.62695"
        strokeWidth="1.2525"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={fill}
      />
    </svg>
  )
}
